/* loaded by smart-asset */
export default require("./39-box-m~bjJegJFs.svg")